import { Provider, WorkflowComponentParamType, WorkflowVariable } from '@cloud-native/workflows-engine'
import { QueryParameters } from '@deck.gl/carto'

export function formatQueryParams({
  variables,
  provider
}: {
  variables: WorkflowVariable[]
  provider: Provider
}): QueryParameters {
  const isBigQuery = provider == Provider.BigQuery
  const initialValue = isBigQuery ? {} : []

  return variables.reduce((acc, item) => {
    let value: string | number = item.value
    if (item.type === WorkflowComponentParamType.Number) {
      value = Number(item.value)
    }
    if (isBigQuery) {
      acc[item.name] = value
    } else {
      ;(acc as unknown[]).push(value)
    }
    return acc
  }, initialValue)
}

export function variablesToParameters({
  variables,
  provider,
  hasOutputNode
}: {
  variables?: WorkflowVariable[]
  provider?: Provider
  hasOutputNode?: boolean
}) {
  variables ||= []
  provider ||= Provider.BigQuery

  let parameters: string[]
  const paramsList = formatQueryParams({ variables, provider })

  switch (provider) {
    case Provider.BigQuery:
      parameters = Object.entries(paramsList).map(([key]) => `@${key}`)
      break
    case Provider.Snowflake:
      parameters = (paramsList as unknown[]).map((_, index) => `:${index + 1}`)
      break
    default:
      parameters = (paramsList as unknown[]).map((_, index) => `$${index + 1}`)
  }

  if (hasOutputNode && provider && [Provider.Redshift, Provider.Postgres].includes(provider)) {
    // Add NULL for the INOUT params in RS/PG if the output component is used
    parameters.push('NULL')
  }

  return parameters
}
